export default "__VITE_ASSET__B9WCX1aw__"